import React from 'react'

export default function Post({post}) {
  return (
    <div className="post mt-5">
    <div className="title">{post.title}</div>
    <hr/>
    <div className="content">{  post.content }</div>
  </div>
  )
}
